import { PermissionGuard } from '@/auth/guard';
import { OrionAccess, OrionModule, OrionSubmodule } from '@/types';
import {
  PartnerListPage,
  PartnerEditPage,
  PartnerTabsPage,
  PartnerCreatePage,
  PartnerContactEditPage,
  PartnerProviderEditPage,
  PartnerContactCreatePage,
  PartnerProviderCreatePage,
  PartnerInformationEditPage,
} from './imports';

export const partnerRoutes = [
  {
    path: 'partners',
    children: [
      {
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PARTNER}
            access={OrionAccess.VIEW}
          >
            <PartnerListPage />
          </PermissionGuard>
        ),
        index: true,
      },
      {
        path: 'list',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PARTNER}
            access={OrionAccess.VIEW}
          >
            <PartnerListPage />
          </PermissionGuard>
        ),
      },
      {
        path: 'new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PARTNER}
            access={OrionAccess.CREATE}
          >
            <PartnerCreatePage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PARTNER}
            access={OrionAccess.UPDATE}
          >
            <PartnerEditPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/information/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PARTNER}
            access={OrionAccess.VIEW}
          >
            <PartnerInformationEditPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/contacts/new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PARTNER}
            access={OrionAccess.VIEW}
          >
            <PartnerContactCreatePage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/contacts/:contact/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PARTNER}
            access={OrionAccess.VIEW}
          >
            <PartnerContactEditPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/consoles/new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PARTNER}
            access={OrionAccess.VIEW}
          >
            <PartnerProviderCreatePage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/consoles/:provider/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PARTNER}
            access={OrionAccess.VIEW}
          >
            <PartnerProviderEditPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/:tab',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PARTNER}
            access={OrionAccess.VIEW}
          >
            <PartnerTabsPage />
          </PermissionGuard>
        ),
      },
    ],
  },
];
